<template>
  <b-modal
    id="edit-site-modal"
    title="Site Edit Modal"
    centered
    hide-footer
    size="lg"
    @hidden="reset"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <template #modal-title>
      <h2 class="m-0">Edit Site</h2>
    </template>
    <validation-observer ref="siteEditFormValidation">
      <b-form @submit.prevent enctype="multipart/form-data">
        <b-form-group label-for="name">
          <template #label>
            Site Name <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="name"
            v-model="name"
            v-restrict="regex"
            placeholder="Name"
            required
          />
        </b-form-group>

        <b-form-group label-for="total_staff">
          <template #label>
            Total Staff 
          </template>
          <b-form-input
            id="total_staff"
            v-model="total_staff"
            placeholder="Staff"
            type="number"
            
          />
        </b-form-group>

         <b-form-group label-for="trained_staff">
          <template #label>
            Trained Staff
          </template>
          <b-form-input
            id="trained_staff"
            v-model="trained_staff"
            placeholder="Trained Staff"
            type="number"
            
          />
        </b-form-group>

        <b-form-group label-for="postcode">
          <template #label>
            PostCode 
          </template>
          <b-form-input
            id="postcode"
            v-model="postcode"
            placeholder="PostCode"
            type="number"
            
          />
        </b-form-group>

        
        

        <b-form-group class="mt-2 text-right">
          <b-button
            type="submit"
            variant="primary"
            pill
            class="mr-1"
            @click="submit"
          >
            Save
          </b-button>
          <b-button
            type="reset"
            variant="outline-secondary"
            @click="reset"
            pill
          >
            Reset
          </b-button>
        </b-form-group>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
  
<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor
  },
  mixins: [util],
  props: {
    site: Object,
  },
  data() {
    return {
      required,
      name: "",
      regex: /^[a-zA-Z ]*$/,
      total_staff: "",
      trained_staff: "",
      postcode: "",
    };
  },
  async mounted() {
    if (this.site) {
      this.name = this.site.name;
      if (this.site.total_staff){
        this.total_staff = this.site.total_staff ;
      }
      if (this.site.trained_staff){
        this.trained_staff = this.site.trained_staff;
      }
      if (this.site.postcode){
        this.postcode = this.site.postcode;
      }
    }
  },
  methods: {
    ...mapActions({
      updateSite: "appData/updateSite",
    }),
    
    async validationForm() {
      const success = await this.$refs.siteEditFormValidation.validate();
      if (success) {
        await this.submit();
      }
    },
    async submit() {
      try {
        const formData = new FormData();
        formData.append("name", this.name);
        formData.append("total_staff", this.total_staff);
        formData.append("trained_staff", this.trained_staff);
        formData.append("postcode", this.postcode);
        formData.append('updated_by', this.getLoggedInUser.id); 
        const res = await this.updateSite({
          payload: formData,
          pk: this.site.id,
        });
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Site Updated Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          this.reset();
          this.$nextTick(() => {
            this.$bvModal.hide("edit-site-modal");
          });
          this.$emit("modalClosed");
        }
      } catch (error) {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: "Site name is required.",
              variant: "danger",
              icon: "BellIcon",
            },
          },
          {
            position: "top-right",
          }
        );
      }
    },

    reset() {
      this.name = "";
      this.total_staff = "";
      this.trained_staff = "";
      this.postcode = "";
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
  },
};
</script>

<style></style>
